import express from 'express';
import path from 'path';
import dotenv from 'dotenv';
import fs from 'fs';
import { authRouter } from './server/routes/auth';
import { classesRouter } from './server/routes/classes';
import { studentsRouter } from './server/routes/students';
import { scheduleRouter } from './server/routes/schedule';
import { attendanceRouter } from './server/routes/attendance';
import { salaryRouter } from './server/routes/salary';
import { invoicesRouter } from './server/routes/invoices';
import { sheetsRouter } from './server/routes/sheets';
import { zaloRouter } from './server/routes/zalo';
import { aiRouter } from './server/routes/gemini';
import { adminRouter } from './server/routes/admin';
import { sepayRouter } from './server/routes/sepay';
import { db } from './server/storage';

dotenv.config();

const app = express();
const PORT = process.env.PORT ? parseInt(process.env.PORT) : 3000;

app.use(express.json());

// API Routes
app.get('/api/health', (req, res) => {
  res.json({ status: 'ok', timestamp: new Date().toISOString() });
});

app.get('/api/system-settings', (req, res) => {
  res.json(db.getSystemSettings());
});

app.use('/api/auth', authRouter);
app.use('/api/admin', adminRouter);
app.use('/api/sepay', sepayRouter);
app.use('/api/classes', classesRouter);
app.use('/api/students', studentsRouter);
app.use('/api/schedule', scheduleRouter);
app.use('/api/attendance', attendanceRouter);
app.use('/api/salary', salaryRouter);
app.use('/api/invoices', invoicesRouter);
app.use('/api/sheets', sheetsRouter);
app.use('/api/zalo', zaloRouter);
app.use('/api/ai', aiRouter);

// Serve static dist files in cPanel
let distPath = path.join(__dirname, 'dist');
if (!fs.existsSync(distPath)) {
  distPath = path.join(process.cwd(), 'dist');
}
if (!fs.existsSync(distPath) && fs.existsSync(path.join(__dirname, 'index.html'))) {
  distPath = __dirname;
}

app.use(express.static(distPath));
app.get('*', (req, res) => {
  res.sendFile(path.join(distPath, 'index.html'));
});

// Start listener directly (required for cPanel Phusion Passenger)
app.listen(PORT, () => {
  console.log(`🚀 Tutor Management Server running on port ${PORT}`);
});

// Export app for Phusion Passenger
export default app;
